'use client';

import { useTranslation } from 'react-i18next';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import InquiryBoardCreate from '@/components/apps/pages/inquiry/Create';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';
import type { InquirySubmitAction } from '@/components/apps/ui/inquiryForm/inquirySubmission';

type Props = {
  submitAction: InquirySubmitAction;
};

export default function InquiryPageClient({ submitAction }: Props) {
  const { t } = useTranslation('common');
  const title = t('문의하기');

  return (
    <>
      <VisuallyHiddenPageTitle>{title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout
        desktopPadding={{ top: '0', bottom: '200px' }}
        mobilePadding={{ top: '0', bottom: '100px' }}
      >
        <InquiryBoardCreate submitAction={submitAction} />
      </ResponsiveLayout>
    </>
  );
}
